import {
  APB,
  ACROSS_LOGO,
  AUTH_GRAPHICS,
  APB_ILLUSTRATION,
} from "../../assets";
import React from "react";
import authStyles from "./styles";
import { Col } from "react-bootstrap";
import { getLanguage } from "../../utils/localization";
import { Box, Paper, Typography } from "@mui/material";

const AuthLayout = ({ children }) => {
  return (
    <Box sx={{ ...authStyles.root, backgroundImage: `url(${AUTH_GRAPHICS})` }}>
      <Paper elevation={3} sx={authStyles.paper}>
        <Box sx={authStyles.leftSection}>
          {/* <Box
            alt="Logo"
            component="img"
            src={ACROSS_LOGO}
            sx={authStyles.logo}
          /> */}
          <Col xs={6} md={6} className="d-flex align-items-center">
            <img
              alt="Apb Logo"
              className="img-fluid me-3"
              src={APB}
              width={150}
            />
            <img
              alt="Across Logo"
              className="img-fluid"
              src={ACROSS_LOGO}
              width={150}
            />
          </Col>

          {/* <Typography variant="h6" sx={authStyles.title}>
            {getLanguage("AUTH_LNG.BFMS")}
          </Typography> */}

          <Typography variant="body2" sx={authStyles.SubTitle}>
            {getLanguage("AUTH_LNG.BFMS_TWO")}
          </Typography>

          {/* <Typography variant="h5" sx={authStyles.title}>
            {getLanguage("AUTH_LNG.BFMS")}
          </Typography>

          <Typography variant="body2" sx={authStyles.description}>
            {getLanguage("AUTH_LNG.BFMS_DES")}
          </Typography>

          <Typography variant="body2" sx={authStyles.description} mb={3}>
            {getLanguage("AUTH_LNG.BFMS_DES_TWO")}
          </Typography> */}
          <Col>
            <img
              alt="Across Logo"
              className="img-fluid"
              src={APB_ILLUSTRATION}
              width={300}
            />
          </Col>

          {/* <Box sx={authStyles.socialIconsContainer}>
            {[<FacebookIcon />, <TwitterIcon />, <LinkedInIcon />].map(
              (icon, index) => (
                <Box key={index} sx={authStyles.socialIcon}>
                  {icon}
                </Box>
              )
            )}
          </Box> */}

          {/* <Box sx={authStyles.footerLinks}>
            <Link href="#" sx={authStyles.link}>
              {getLanguage("AUTH_LNG.PP")}
            </Link>
            <Link href="#" sx={authStyles.link}>
              {getLanguage("AUTH_LNG.CNTCT")}
            </Link>
          </Box> */}

          <Typography variant="body2" sx={authStyles.footerText}>
            {getLanguage("AUTH_LNG.CPRYT")}
          </Typography>
        </Box>

        <Box sx={authStyles.rightSection}>{children}</Box>
      </Paper>
    </Box>
  );
};

export default AuthLayout;
